/**
 * @generated SignedSource<<b7f838c72b863de4b5472d213783f520>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductExpireBatchFilter = "ONLY_ACTIONS";
export type ProductExpireBatchFilterSortField = "CREATED_AT" | "EXPIRE_AT";
export type ProductDateTrackerQuery$variables = {
  after?: string | null;
  filter?: ProductExpireBatchFilter | null;
  first?: number | null;
  order: ProductExpireBatchFilterSortField;
};
export type ProductDateTrackerQuery$data = {
  readonly currentStore: {
    readonly " $fragmentSpreads": FragmentRefs<"ProductDateTrackerList_Store">;
  };
};
export type ProductDateTrackerQuery = {
  response: ProductDateTrackerQuery$data;
  variables: ProductDateTrackerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "order"
},
v4 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "order"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isoString",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "timezone",
    "storageKey": null
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductDateTrackerQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "Store",
          "kind": "LinkedField",
          "name": "currentStore",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ProductDateTrackerList_Store"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProductDateTrackerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "currentStore",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "StoreProductExpireBatchConnection",
            "kind": "LinkedField",
            "name": "productExpireBatches",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreProductExpireBatchEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreProductExpireBatch",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoreProductExpireBatchAction",
                        "kind": "LinkedField",
                        "name": "activeAction",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StoreZonedDate",
                            "kind": "LinkedField",
                            "name": "startAtDate",
                            "plural": false,
                            "selections": (v6/*: any*/),
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "label",
                            "storageKey": null
                          },
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoreZonedDate",
                        "kind": "LinkedField",
                        "name": "expireAtDate",
                        "plural": false,
                        "selections": (v6/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoreProduct",
                        "kind": "LinkedField",
                        "name": "product",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "imageUrl",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "partNumber",
                            "storageKey": null
                          },
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isProductDetails"
                          }
                        ],
                        "storageKey": null
                      },
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v4/*: any*/),
            "filters": [
              "filter",
              "orderBy"
            ],
            "handle": "connection",
            "key": "ProductDateTracker__productExpireBatches",
            "kind": "LinkedHandle",
            "name": "productExpireBatches"
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ce4c9a7e8117889f9c67f0b7a7094674",
    "id": null,
    "metadata": {},
    "name": "ProductDateTrackerQuery",
    "operationKind": "query",
    "text": "query ProductDateTrackerQuery(\n  $first: Int\n  $after: String\n  $filter: ProductExpireBatchFilter\n  $order: ProductExpireBatchFilterSortField!\n) {\n  currentStore {\n    ...ProductDateTrackerList_Store\n    id\n  }\n}\n\nfragment ProductDateTrackerList_Store on Store {\n  productExpireBatches(after: $after, first: $first, filter: $filter, orderBy: $order) {\n    edges {\n      cursor\n      node {\n        id\n        activeAction {\n          startAtDate {\n            isoString\n            timezone\n          }\n          id\n        }\n        ...ProductExpireBatchListItem_StoreProductExpireBatch\n        expireAtDate {\n          isoString\n          timezone\n          ...StoreRelativeZonedDate_StoreZonedDate\n        }\n        status\n        product {\n          id\n          name\n          imageUrl\n          partNumber\n          ...ProductHeader_ProductDetails\n          ...ProductExpireBatchProductPreview_StoreProduct\n        }\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment ProductExpireBatchListItemAction_StoreProductExpireBatchAction on StoreProductExpireBatchAction {\n  id\n  label\n  status\n  startAtDate {\n    isoString\n    timezone\n    ...StoreRelativeZonedDate_StoreZonedDate\n  }\n}\n\nfragment ProductExpireBatchListItemContent_StoreProductExpireBatch on StoreProductExpireBatch {\n  id\n  expireAtDate {\n    isoString\n  }\n  product {\n    id\n    name\n    imageUrl\n  }\n}\n\nfragment ProductExpireBatchListItem_StoreProductExpireBatch on StoreProductExpireBatch {\n  id\n  activeAction {\n    id\n    ...ProductExpireBatchListItemAction_StoreProductExpireBatchAction\n  }\n  ...ProductExpireBatchListItemContent_StoreProductExpireBatch\n}\n\nfragment ProductExpireBatchProductPreview_StoreProduct on StoreProduct {\n  id\n  name\n  partNumber\n  imageUrl\n}\n\nfragment ProductHeader_ProductDetails on ProductDetails {\n  __isProductDetails: __typename\n  imageUrl\n  partNumber\n  name\n}\n\nfragment StoreRelativeZonedDate_StoreZonedDate on StoreZonedDate {\n  isoString\n  timezone\n}\n"
  }
};
})();

(node as any).hash = "ded5cd0b02641b63314cc4215a774e7d";

export default node;
